// extracted by mini-css-extract-plugin
export default {"root":"_2JS7fyOu","reveal":"_2EUwceGt","closing":"vQIQPdOi","hide":"_2ZlzBuLO","success":"_1u0n0f_6","danger":"_147Ab1oC","close":"_2Valn5vr"};